const problems = [
  { icon: 'ri-shopping-cart-line', text: 'Покупают модный тренинг, а не решение бизнес-задачи' },
  { icon: 'ri-group-line', text: 'Обучают всех одинаково, без учёта роли и уровня сотрудников' },
  { icon: 'ri-link-unlink', text: 'Обучение не связано с KPI и реальными показателями бизнеса' },
  { icon: 'ri-search-line', text: 'Нет диагностики — не знают, чему именно нужно учить' },
  { icon: 'ri-tools-line', text: 'Нет практики — только теория, которая быстро забывается' },
  { icon: 'ri-rocket-line', text: 'Нет внедрения — знания остаются в блокнотах, а не в работе' },
  { icon: 'ri-bar-chart-line', text: 'Нет оценки результатов — невозможно понять, что изменилось' },
];

export default function WhyUniversalTrainingFails() {
  return (
    <section id="why-universal-fails" className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему универсальные тренинги редко работают
        </h2>
        <p className="text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto leading-relaxed">
          Большинство компаний совершают одни и те же ошибки при выборе обучения
        </p>

        <div className="grid sm:grid-cols-2 gap-5 mb-12">
          {problems.map((p, i) => (
            <div key={i} className="flex items-start gap-4 p-5 bg-red-50/70 rounded-xl border border-red-100">
              <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className={`${p.icon} text-lg text-red-500`}></i>
              </div>
              <p className="text-gray-700 leading-relaxed pt-1.5">{p.text}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-600 rounded-2xl p-8 md:p-12 text-center max-w-4xl mx-auto">
          <i className="ri-lightbulb-line text-4xl text-white/70 mb-4 block"></i>
          <p className="text-xl md:text-2xl font-bold text-white leading-relaxed">
            Хорошая программа обучения начинается не с выбора тренинга, а с понимания бизнес-задачи.
          </p>
        </div>
      </div>
    </section>
  );
}